export default __webpack_public_path__ + "static/media/a0.5c0f9e90.jpg";